import R from 'ramda';
import React from 'react';
import update from 'react/lib/update';
import { Exit, ProgressBar, FilledButton, UploadErrorDialog, ImageLimitErrorDialog, FileTypeErrorDialog } from '../app/components';
import { connect } from 'react-redux';
import { fields } from '../../common/lib/redux-fields';
import { createPropertyWithImages } from '../../common/properties/actions';
import {
  onSelectType, onIncreaseBedrooms, onDecreaseBedrooms, formatDate,
  onFromDateChange, onToDateChange, onSelectProsCons, onImageChange,
  onDeselectImage, onSelectContactInfo, assignRef,
} from '../../common/properties/formFunctions';
import moment from 'moment';
import './styles.css';
import AddressStep from '../steps/AddressStep/AddressStep';
import ZipStep from '../steps/ZipStep/ZipStep';
import TypeStep from '../steps/TypeStep/TypeStep';
import SizeStep from '../steps/SizeStep/SizeStep';
import DateStep from '../steps/DateStep/DateStep';
import PriceStep from '../steps/PriceStep/PriceStep';
import InsuranceStep from '../steps/InsuranceStep/InsuranceStep';
import ProsConsStep from '../steps/ProsConsStep/ProsConsStep';
import ImagesStep from '../steps/ImagesStep/ImagesStep';
import DescriptionStep from '../steps/DescriptionStep/DescriptionStep';
import TitleStep from '../steps/TitleStep/TitleStep';
import ContactStep from '../steps/ContactStep/ContactStep';
import SummaryStep from '../steps/SummaryStep/SummaryStep';

let GoogleMapLoader = null;
let GoogleMap = null;
let Marker = null;
let loadImage = null;
let exif = null;

class PropertyCreate extends React.Component {
  constructor(props) {
    super(props);
    const { fields, viewer } = this.props;

    fields.$setValue('insuranceType', 'Samkomulag');
    fields.$setValue('rentTimeType', 'Langtímaleiga');
    fields.$setValue('contactEmailValue', (viewer && viewer.email) ? viewer.email : '');
    fields.$setValue('contactPhonenumberValue', '');
    fields.$setValue('availableFrom', moment().format('YYYY-MM-DD'));
    fields.$setValue('availableTo', moment().format('YYYY-MM-DD'));
    fields.$setValue('bedrooms', 0);
    fields.$setValue('bathIncluded', false);
    fields.$setValue('dishwasherIncluded', false);
    fields.$setValue('electricityIncluded', false);
    fields.$setValue('fridgeIncluded', false);
    fields.$setValue('furnitureIncluded', false);
    fields.$setValue('heatIncluded', false);
    fields.$setValue('petsAllowed', false);
    fields.$setValue('showerIncluded', false);
    fields.$setValue('smokingAllowed', false);
    fields.$setValue('stoveIncluded', false);
    fields.$setValue('washingMachineIncluded', false);
    fields.$setValue('dryingMachineIncluded', false);
    fields.$setValue('contactFacebook', true);
    fields.$setValue('contactEmail', false);
    fields.$setValue('contactPhonenumber', false);
    this.state = {
      step: 0,
      totalSteps: 13,
      center: {
        lat: 64.144835,
        lng: -21.932991,
      },
      marker: {
        lat: 64.146835,
        lng: -21.932991,
      },
      imageFiles: [],
      imagePreviewUrls: [],
      uploadImageError: false,
      imageLimitExceeded: false,
      fileTypeError: false,
      numberOfImages: 0,
    };
  }

  componentWillMount = () => {
    GoogleMapLoader = require('react-google-maps').GoogleMapLoader;
    GoogleMap = require('react-google-maps').GoogleMap;
    Marker = require('react-google-maps').Marker;
    loadImage = require('blueimp-load-image');
    exif = require('exif-js');
  }

  componentDidMount = () => {
    if (this.address) { this.address.refs.input.focus(); }
    document.addEventListener('keydown', this.handleDocumentKeyDown);
  }

  componentWillUnmount = () => {
    const { fields } = this.props;
    fields.$reset();
    document.removeEventListener('keydown', this.handleDocumentKeyDown);
  }

  onMoveImage = (id, atIndex) => {
    const { imagePreviewUrl, imageFile, index } = this.findImage(id);
    this.setState(update(this.state, {
      imagePreviewUrls: {
        $splice: [
          [index, 1],
          [atIndex, 0, imagePreviewUrl],
        ],
      },
      imageFiles: {
        $splice: [
          [index, 1],
          [atIndex, 0, imageFile],
        ],
      },
    }));
  }

  onSuggestSelect = (e) => {
    const { fields } = this.props;
    fields.$setValue('address', e.label);
    if (e.location) {
      this.setLatLng(e.location.lat, e.location.lng);
    }
  }

  onFormSubmit = (e) => {
    const { createPropertyWithImages, fields, viewer } = this.props;
    const { imageFiles } = this.state;
    e.preventDefault();

    const newProperty = {
      ownerId: viewer.id,
      address: fields.address.value.indexOf(',') !== -1 ?
        fields.address.value.substring(0, fields.address.value.indexOf(',')).trim() :
        fields.address.value.trim(),
      zip: parseInt(fields.zip.value, 10),
      type: fields.type.value.trim(),
      title: fields.title.value.trim(),
      description: fields.description.value.trim(),
      insuranceType: fields.insuranceType.value.trim(),
      insuranceAmount: parseInt(fields.insuranceAmount.value.replace(/\./g, ''), 10),
      bedrooms: parseInt(fields.bedrooms.value, 10),
      price: parseInt(fields.price.value.replace(/\./g, ''), 10),
      size: parseInt(fields.size.value.replace(/\./g, ''), 10),
      latitude: parseFloat(fields.latitude.value),
      longitude: parseFloat(fields.longitude.value),
      bathIncluded: fields.bathIncluded.value,
      dishwasherIncluded: fields.dishwasherIncluded.value,
      electricityIncluded: fields.electricityIncluded.value,
      fridgeIncluded: fields.fridgeIncluded.value,
      furnitureIncluded: fields.furnitureIncluded.value,
      heatIncluded: fields.heatIncluded.value,
      petsAllowed: fields.petsAllowed.value,
      showerIncluded: fields.showerIncluded.value,
      smokingAllowed: fields.smokingAllowed.value,
      stoveIncluded: fields.stoveIncluded.value,
      washingMachineIncluded: fields.washingMachineIncluded.value,
      dryingMachineIncluded: fields.dryingMachineIncluded.value,
      createdAt: moment().toString(),
      availableFrom: fields.availableFrom.value.trim(),
      availableTo: fields.rentTimeType.value === 'Langtímaleiga' ? '' : fields.availableTo.value.trim(),
      contactFacebook: fields.contactFacebook.value ? viewer.facebookId : '',
      contactEmail: fields.contactEmail.value ? fields.contactEmailValue.value.trim() : '',
      contactPhonenumber: fields.contactPhonenumber.value ? fields.contactPhonenumberValue.value.trim() : '',
      active: true,
      views: 0,
    };

    createPropertyWithImages(newProperty, imageFiles);
    fields.$reset();
  }

  onDragend = (e) => {
    if (e.latLng) {
      this.setLatLng(e.latLng.lat(), e.latLng.lng());
    }
  }

  onInputKeyDown = (e) => {
    if (e.keyCode === 13 || e.charCode === 13) { e.preventDefault(); }
    if ((e.keyCode === 13 || e.charCode === 13) && this.validate()) { this.nextStep(e); }
  }

  setNumberOfImages = (number, cb) => {
    this.setState({ numberOfImages: number }, cb);
  }

  setLatLng = (lat, lng) => {
    const { fields } = this.props;

    fields.$setValue('latitude', lat);
    fields.$setValue('longitude', lng);

    this.setState({
      center: { lat: lat - 0.002, lng },
      marker: { lat, lng },
    });
  }

  findImage = (id) => {
    const { imagePreviewUrls, imageFiles } = this.state;
    const imagePreviewUrl = imagePreviewUrls.filter(imagePreviewUrl =>
      imagePreviewUrl.key === id)[0];
    const imageFile = imageFiles.filter(imageFile =>
      imageFile.key === id)[0];
    return {
      imagePreviewUrl,
      imageFile,
      index: imagePreviewUrls.indexOf(imagePreviewUrl),
    };
  }

  handleDocumentKeyDown = (e) => {
    const { step } = this.state;
    const { fields } = this.props;

    if (step === 3 && e.keyCode === 38) { onIncreaseBedrooms(e, fields); }
    if (step === 3 && e.keyCode === 40) { onDecreaseBedrooms(e, fields); }
  }

  validate = () => {
    const { fields } = this.props;
    const { step, imagePreviewUrls } = this.state;

    if (step === 0 && fields.address.value !== '') { return true; }
    if (step === 1 && fields.zip.value.length === 3) { return true; }
    if (step === 2 && fields.type.value !== '') { return true; }
    if (step === 3 && fields.bedrooms.value >= 0 && fields.size.value !== '') { return true; }
    if (step === 4) { return true; }
    if (step === 5 && fields.price.value !== '') { return true; }
    if (step === 6 && fields.insuranceAmount.value !== '' && fields.insuranceType.value !== '') { return true; }
    if (step === 7) { return true; }
    if (step === 8 && imagePreviewUrls.length !== 0) { return true; }
    if (step === 9 && fields.description.value !== '') { return true; }
    if (step === 10 && fields.title.value !== '') { return true; }
    if ((step === 11) &&
      (fields.contactEmail.value ||
        fields.contactPhonenumber.value ||
        fields.contactFacebook.value) &&
      (!fields.contactEmail.value || fields.contactEmailValue.value !== '') &&
      (!fields.contactPhonenumber.value ||
        fields.contactPhonenumberValue.value.length === 7)) { return true; }
    if (step === 12) { return true; }

    return false;
  }

  focusInputField = () => {
    const { step } = this.state;

    if (step === 0) { this.address.refs.input.focus(); }
    if (step === 1) { this.zip.input.refs.input.focus(); }
    if (step === 3) { this.size.input.refs.input.focus(); }
    if (step === 5) { this.price.input.refs.input.focus(); }
    if (step === 6) { this.insuranceAmount.input.refs.input.focus(); }
    if (step === 9) { this.description.input.refs.input.focus(); }
    if (step === 10) { this.title.input.focus(); }
  }

  nextStep = (e) => {
    e.preventDefault();

    this.setState({
      step: this.state.step + 1,
    }, this.focusInputField);
  }

  prevStep = (e) => {
    e.preventDefault();

    this.setState({
      step: this.state.step - 1,
    }, this.focusInputField);
  }

  renderMap = () => {
    const { center, marker } = this.state;

    return (
      <div>
        {GoogleMapLoader && GoogleMap && Marker ?
          <div className="maps-container">
            <GoogleMapLoader
              containerElement={<div className="map-wrapper" />}
              googleMapElement={
                <GoogleMap
                  defaultZoom={15}
                  center={{ lat: center.lat, lng: center.lng }}
                  draggable
                  defaultOptions={{ disableDefaultUI: true }}
                >
                  <Marker
                    ref={(m) => { this.marker = m; }}
                    onDragend={this.onDragend}
                    position={{ lat: marker.lat, lng: marker.lng }}
                    defaultAnimation={2}
                    icon="https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/google-maps-pin.png?alt=media&token=72361491-12f0-4210-8a37-8e4914c44b08"
                    cursor="pointer"
                    draggable
                    visible
                  />
                </GoogleMap>
              }
            />
          </div>
        :
          null
        }
      </div>
    );
  }

  render() {
    const { fields, location } = this.props;
    const {
      step, totalSteps, imageFiles, imagePreviewUrls, uploadImageError,
      imageLimitExceeded, fileTypeError, numberOfImages,
    } = this.state;

    return (
      <form className="property-create">
        <UploadErrorDialog
          component={this}
          uploadImageError={uploadImageError}
        />
        <ImageLimitErrorDialog
          component={this}
          imageLimitExceeded={imageLimitExceeded}
        />
        <FileTypeErrorDialog
          component={this}
          fileTypeError={fileTypeError}
        />
        {step === 0 && this.renderMap()}
        <div className={`card${step === 0 ? ' first-step' : ''}${step === 12 || step === 9 || step === 7 ? ' big' : ''}`}>
          <div className={`header-wrapper ${step === 0 ? ' first-step' : ''}`}>
            <Exit
              to={location.state ? location.state.from : '/'}
              color={step === 0 ? '#ffffff' : '#000000'}
              requireConfirm
            />
            {step !== 0 &&
              <h2>Skrá nýja eign</h2>
            }
          </div>
          <ProgressBar percentage={((step + 1) / totalSteps) * 100} />
          {step === 0 &&
            <AddressStep
              fields={fields} assignRef={(field, c) => assignRef(this, field, c)}
              onSuggestSelect={this.onSuggestSelect} onInputKeyDown={this.onInputKeyDown}
            />
          }
          {step === 1 &&
            <ZipStep
              fields={fields} assignRef={(field, c) => assignRef(this, field, c)}
              onInputKeyDown={this.onInputKeyDown}
            />
          }
          {step === 2 &&
            <TypeStep fields={fields} onSelectType={onSelectType} />
          }
          {step === 3 &&
            <SizeStep
              fields={fields} onInputKeyDown={this.onInputKeyDown}
              assignRef={(field, c) => assignRef(this, field, c)}
              onIncreaseBedrooms={onIncreaseBedrooms}
              onDecreaseBedrooms={onDecreaseBedrooms}
            />
          }
          {step === 4 &&
            <DateStep
              fields={fields} formatDate={formatDate}
              onFromDateChange={onFromDateChange} onToDateChange={onToDateChange}
            />
          }
          {step === 5 &&
            <PriceStep
              fields={fields} assignRef={(field, c) => assignRef(this, field, c)}
              onInputKeyDown={this.onInputKeyDown}
            />
          }
          {step === 6 &&
            <InsuranceStep
              fields={fields} assignRef={(field, c) => assignRef(this, field, c)}
              onInputKeyDown={this.onInputKeyDown}
            />
          }
          {step === 7 &&
            <ProsConsStep fields={fields} onSelectProsCons={onSelectProsCons} />
          }
          {step === 8 &&
            <ImagesStep
              imagePreviewUrls={imagePreviewUrls}
              onMoveImage={this.onMoveImage}
              findImage={this.findImage}
              onImageChange={(e) => {
                e.persist();
                const numberOfImages = imagePreviewUrls.length + e.target.files.length;
                this.setNumberOfImages(numberOfImages, () => {
                  onImageChange(e, loadImage, exif, this, imageFiles, imagePreviewUrls, 0);
                });
              }}
              onDeselectImage={(e, key) => {
                e.persist();
                this.setNumberOfImages((numberOfImages - 1), () => {
                  onDeselectImage(e, this, key, imageFiles, imagePreviewUrls);
                });
              }}
              uploadingFiles={numberOfImages !== imagePreviewUrls.length}
            />
          }
          {step === 9 &&
            <DescriptionStep fields={fields} assignRef={(field, c) => assignRef(this, field, c)} />
          }
          {step === 10 &&
            <TitleStep
              fields={fields} assignRef={(field, c) => assignRef(this, field, c)}
              onInputKeyDown={this.onInputKeyDown}
            />
          }
          {step === 11 &&
            <ContactStep
              fields={fields} assignRef={(field, c) => assignRef(this, field, c)}
              onSelectContactInfo={
                (isInputChecked, input) =>
                  onSelectContactInfo(this, fields, isInputChecked, input)
              }
            />
          }
          {step === 12 &&
            <SummaryStep fields={fields} imagePreviewUrls={imagePreviewUrls} />
          }
          <div className="button-group">
            {step !== 0 &&
              <FilledButton
                className="no-icon"
                content={<p>Til baka</p>}
                disabled={false}
                color="#222222"
                backgroundColor="#ffffff"
                onClick={this.prevStep}
              />
            }
            <FilledButton
              className="no-icon"
              content={step === 12 ? <p>Setja í loftið</p> : <p>Næsta skref</p>}
              disabled={!this.validate()}
              color="#222222"
              backgroundColor="#00e39a"
              onClick={step === 12 ? this.onFormSubmit : this.nextStep}
            />
          </div>
        </div>
      </form>
    );
  }
}

PropertyCreate.propTypes = {
  location: React.PropTypes.any,
  fields: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object,
  createPropertyWithImages: React.PropTypes.func.isRequired,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
    }),
    { createPropertyWithImages },
  ),
  fields({
    path: 'createProperty',
    fields: [
      'address',
      'zip',
      'latitude',
      'longitude',
      'type',
      'title',
      'bedrooms',
      'size',
      'availableFrom',
      'availableTo',
      'rentTimeType',
      'price',
      'insuranceAmount',
      'insuranceType',
      'bathIncluded',
      'dishwasherIncluded',
      'electricityIncluded',
      'fridgeIncluded',
      'furnitureIncluded',
      'heatIncluded',
      'petsAllowed',
      'showerIncluded',
      'smokingAllowed',
      'stoveIncluded',
      'washingMachineIncluded',
      'dryingMachineIncluded',
      'description',
      'contactFacebook',
      'contactEmail',
      'contactPhonenumber',
      'contactEmailValue',
      'contactPhonenumberValue',
    ],
  }),
)(PropertyCreate);



// WEBPACK FOOTER //
// ./src/browser/propertyCreate/PropertyCreate.js